import CryptoJS from 'crypto-js';

const STORAGE_KEY = 'kaarya_user';
const SECRET_KEY = 'kaaryaalaya_v2_client_key';

const fromUrlSafe = (str) => str.replace(/-/g, '+').replace(/_/g, '/');

const decryptStored = () => {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw || typeof raw !== 'string') return null;
    const parts = raw.split('://');
    const cipherUrlSafe = parts.length === 2 ? parts[1] : raw;
    const cipher = fromUrlSafe(cipherUrlSafe);
    const bytes = CryptoJS.AES.decrypt(cipher, SECRET_KEY);
    const json = bytes.toString(CryptoJS.enc.Utf8);
    if (!json) return null;
    return JSON.parse(json);
  } catch (_) {
    return null;
  }
};

const AuthService = {
  getApiKey() {
    const data = decryptStored();
    return data?.apiKey || null;
  },

  // Returns the full decrypted payload stored in localStorage.
  getUser() {
    return decryptStored();
  },

  // Lightweight helper for screens that only need high-level user info
  // (shape tailored for Tickets.jsx and similar views).
  getUserInfo() {
    const data = decryptStored();
    if (!data) return null;

    const selected = data.selectedRegistration || null;
    const student = data.student || null;

    const registrationNumber =
      selected?.registrationNumber || student?.registrationNumber || null;

    return {
      // Student portal uses only student logins today
      type: data.type || 'student',
      registrationNumber,
      studentId: data.studentId || student?.studentId || null,
      studentName: student?.fullName || null,
      raw: data,
    };
  },

  // Helper to expose currently selected course/registration context.
  // This is essentially the "selectedRegistration" object from the
  // encrypted payload, normalized to a smaller shape.
  getCourseInfo() {
    const data = decryptStored();
    if (!data) return null;

    const selected = data.selectedRegistration;
    if (!selected) return null;

    return {
      registrationId: selected.registrationId,
      registrationNumber: selected.registrationNumber,
      courseId: selected.courseId,
      courseName: selected.courseName || selected.courseShortName || null,
      courseShortName: selected.courseShortName || null,
      batchId: selected.batchId,
      batchName: selected.batchName,
      raw: selected,
    };
  },

  clear() {
    try {
      window.localStorage.removeItem(STORAGE_KEY);
    } catch (_) {}
  },
};

export default AuthService;
